import { render } from "./pb-pagetitle.vue?vue&type=template&id=7b591467"
import script from "./pb-pagetitle.vue?vue&type=script&lang=js"
export * from "./pb-pagetitle.vue?vue&type=script&lang=js"

import "./pb-pagetitle.vue?vue&type=style&index=0&id=7b591467&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__